import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { YPageShellSegmentedTabs } from '../../../ui/shell';
import {
  TOOLKIT_SHELL_TABS,
  parseToolkitTab,
  toolkitPathForTab,
} from '../constants/toolkitRoutes';
import './toolkit-shell.css';

/**
 * Shared Toolkit shell tabs (5b-1). Mount at the top of each toolkit page.
 */
export function ToolkitShellTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeId = parseToolkitTab(location.pathname);

  const handleTabChange = useCallback(
    (tabId) => {
      const nextPath = toolkitPathForTab(tabId);
      if (nextPath === location.pathname) return;
      navigate(nextPath);
    },
    [navigate, location.pathname]
  );

  return (
    <div className="toolkit-shell__tabs" data-testid="toolkit-shell-tabs">
      <YPageShellSegmentedTabs
        tabs={TOOLKIT_SHELL_TABS}
        activeId={activeId}
        onTabChange={handleTabChange}
        ariaLabel="Toolkit sections"
      />
      <span className="visually-hidden" data-testid="toolkit-active-tab">
        {activeId}
      </span>
    </div>
  );
}
